<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Atributos</h2>
          <p>
            En este apartado se pueden ver los atributos de producto.<br />
            Los atributos son las características de un producto que los
            usuarios deberán definir a la hora de personalizar un producto.
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de atributos</h3>
              <v-server-table
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <!-- <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{ name: 'AdminProductAttributesNewScreen' }"
                    >Nuevo selector</b-button
                  > -->

                  <!-- <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionados</b-button
                  > -->
                </div>

                <template v-slot:characteristics="props">
                  <span
                    >{{ props.row.definition.views.length }} vistas,
                    {{ props.row.definition.attributes.length }} atributos</span
                  >
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminProductAttributesEditScreen',
                      params: { reference: props.row.reference },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    >Detalles</b-button
                  >

                  <!-- <b-button
                    @click="removeProductSelector(props.row.reference)"
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    >Eliminar</b-button
                  > -->
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'AdminProductAttributesScreen',
  props: {},
  components: {},
  data() {
    return {
      table: {
        url: uris.productAttributesURI,
        selected: [],
        allSelected: false,
        columns: ['reference', 'description'],
        options: {
          sortable: ['name_es'],
          headings: {
            reference: 'Referencia',
            description: 'Descripción',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  methods: {
    removeSelected() {
      this.table.selected.map((x) => {
        this.removeProductSelector(x);
      });
    },
    removeProductSelector(reference) {
      actions.deleteProductSelector(reference).then((x) => {
        this.$refs.table.refresh();
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
